// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bottom[data-v-7e07a8e4]{\n  margin-top: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
